import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import {Translate} from "../../../../config/Translate";
import IconButton from "@material-ui/core/IconButton/IconButton";
import Divider from "@material-ui/core/Divider/Divider";
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import ChevronLeftRoundedIcon from '@material-ui/icons/ChevronLeftRounded';
import axios from "axios";
import {defaultVariabls} from "../../../../config";
import {connect, setStore} from "trim-redux";
import AppCardLoaderFields from "../../../components/Skeletons/AppCardLoaderFields";
import List from "@material-ui/core/List/List";
import {ListItem} from "@material-ui/core";
import ListItemAvatar from "@material-ui/core/ListItemAvatar/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar/Avatar";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction/ListItemSecondaryAction";
import Checkbox from "@material-ui/core/Checkbox/Checkbox";
import Typography from "@material-ui/core/Typography/Typography";
import Alert from "@material-ui/lab/Alert/Alert";
import DialogActions from "@material-ui/core/DialogActions/DialogActions";
import SaveRoundedIcon from "@material-ui/icons/SaveRounded";
import LoadingButton from "../../../components/elements/LoadingButton";
import {withRouter} from "react-router";
import {withSnackbar} from "notistack";
import {withStyles} from "@material-ui/core/styles";
import {Styles} from "../../../../config/design/styles";
import {currencySymbol, price} from "../../../../config/values";

class ParticipateInFestivalButton extends React.Component{
    state = {
        open: false,
        id:this.props.id,
        pricings:[],
        selected_pricings:[],
        loading:false,
        SubmitLoading:false,
    };
    componentDidMount(){
        this.setState({
            id:this.props.id,
        })
        this.loadData();
    }
    async loadData(){
        let loginToken = localStorage.getItem('ACT');
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.get(`${defaultVariabls.url}/my-pricings/getAll/${this.props.id}`, config)
                .then(response => {
                    this.setState({
                        pricings:response.data.pricings,
                        selected_pricings:response.data.selected_pricings,
                        loading:false,
                    })

                }).catch(error => {
                    console.log(error.response)
                    this.setState({
                        loading:false
                    })
                })
        }else {
            setStore({
                isAuth : false,
                user : null,
            });
        }
    }
    componentDidUpdate(prevProps){
        if(this.state.id !== this.props.id){
            this.setState({
                id: this.props.id
            })
        }
    }
    async toggleOpen(){
        await this.setState({
            open: !this.state.open
        })
        if(this.state.open === true){
            this.setState({
                run:true
            })
        }else{
            this.setState({
                run:false
            })
        }
    }
    async handleReload(){
        await this.toggleOpen();
    }
    async handleChangeSelected(id){
        let {selected_pricings} = this.state;
        let index = selected_pricings.indexOf(id);
        if (index > -1) {
            selected_pricings.splice(index, 1);
        }else{
            selected_pricings.push(id)
        }
        await this.setState({
            selected_pricings
        })
    }
    async handleAddAllProducts(){
        let {selected_pricings,pricings} = this.state;
        selected_pricings = [];
        await pricings.map(pricings =>{
            selected_pricings.push(pricings.id)
        })
        await this.setState({
            selected_pricings
        })
    }
    async handleSubmit(e){
        this.setState({
            SubmitLoading: true
        })
        e.preventDefault();
        let {selected_pricings} = this.state;
        let {id} = this.props;
        let data = new FormData();
        data.append('selected_pricings', JSON.stringify(selected_pricings));
        data.append('id', id);

        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        await axios.post(`${defaultVariabls.url}/participate/festival`, data, config)
            .then(response => {
                this.props.enqueueSnackbar(Translate.dataEdited, {
                    variant: 'success',
                });
                this.handleReload();
                this.setState({
                    SubmitLoading: false
                })
            })
            .catch(error => {
                console.log(error.response)
                this.props.enqueueSnackbar(Translate.dataEditingFailed, {
                    variant: 'error',
                });
                this.setState({
                    loading:false,
                    SubmitLoading: false,
                });
            });

    }
    render(){
        let {open,loading,pricings,selected_pricings,SubmitLoading} = this.state;
        return (
            <>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => this.toggleOpen()}
                    endIcon={<ChevronLeftRoundedIcon/>}
                    size={"small"}
                    style={{marginBottom:5,marginRight:5}}
                >
                    {Translate.participate}
                </Button>
                <Dialog
                    open={open}
                    onClose={() => this.toggleOpen()}
                    aria-labelledby="form-dialog-title"
                    fullWidth
                    maxWidth="sm"
                >
                    <DialogTitle id="form-dialog-title">
                        {
                            Translate.participate
                        }
                        <IconButton
                            onClick={() => this.toggleOpen()}
                            style={{position:"absolute",left:15,top:15}}
                            size="small"
                        >
                            <CloseRoundedIcon fontSize="small"/>
                        </IconButton>
                    </DialogTitle>
                    <Divider/>
                    <DialogContent>
                        <Alert>{Translate.participateDesc}</Alert>
                        {
                            !!loading ? <AppCardLoaderFields/>
                                :
                                <>
                                    {
                                        !!pricings.length ?
                                            <>
                                                <Button
                                                    color="primary"
                                                    size="small"
                                                    style={{marginTop:10}}
                                                    variant="contained"
                                                    onClick={()=> this.handleAddAllProducts()}
                                                >
                                                    {Translate.chooseAll}
                                                </Button>
                                                <List dense >
                                                    {pricings.map((pricings) => {
                                                        return (
                                                            <ListItem key={pricings.id} button onClick={()=> this.handleChangeSelected(pricings.id)}>
                                                                <ListItemAvatar>
                                                                    <Avatar
                                                                        src={`${defaultVariabls.uploads}/FileManager/${pricings.product.thumbnail.name}_small.${pricings.product.thumbnail.extension}`}
                                                                    />
                                                                </ListItemAvatar>
                                                                <ListItemText
                                                                    primary={pricings.product.name + (pricings.product.physically === "audiobook" ? " (" + Translate.audiobook+")" : pricings.product.physically === "ebook" ? " (" + Translate.ebook+")" : '')}
                                                                    secondary={price(pricings.price)+" "+currencySymbol}
                                                                />
                                                                <ListItemSecondaryAction>
                                                                    <Checkbox
                                                                        edge="end"
                                                                        checked={selected_pricings.indexOf(pricings.id) !== -1}
                                                                    />
                                                                </ListItemSecondaryAction>
                                                            </ListItem>
                                                        );
                                                    })}
                                                </List>
                                            </>
                                            :
                                            <>
                                            <Typography>{Translate.noProduct}</Typography>
                                            </>
                                    }

                                </>
                        }
                    </DialogContent>
                    <DialogActions>
                        <LoadingButton
                            variant="contained"
                            color="primary"
                            startIcon={<SaveRoundedIcon/>}
                            onClick={this.handleSubmit.bind(this)}
                            loading={SubmitLoading}
                        >
                            {Translate.save}
                        </LoadingButton>
                    </DialogActions>
                </Dialog>
            </>
        );
    }
}
const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user
});
export default withRouter(withSnackbar(withStyles(Styles)(connect(mstp)(ParticipateInFestivalButton))));
